import { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Page shell with ambient violet/cyan glow blobs + faint grid overlay.
 * Use as the outermost wrapper of any "Stitch-aesthetic" page.
 */
export const StitchPage = ({
  children,
  className,
  glow = true,
}: {
  children: ReactNode;
  className?: string;
  glow?: boolean;
}) => (
  <div className={cn("relative min-h-screen text-foreground", className)}>
    {glow && (
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-32 top-0 h-[420px] w-[420px] rounded-full bg-primary/15 blur-[140px]" />
        <div className="absolute -right-32 bottom-0 h-[420px] w-[420px] rounded-full bg-accent/10 blur-[140px]" />
        <div
          className="absolute inset-0 opacity-[0.05]"
          style={{
            backgroundImage:
              "linear-gradient(to right, hsl(var(--primary)) 1px, transparent 1px), linear-gradient(to bottom, hsl(var(--primary)) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
          }}
        />
      </div>
    )}
    <div className="relative z-10">{children}</div>
  </div>
);
